import { render, staticRenderFns } from "./RiseAndFallGraph.vue?vue&type=template&id=f044b404&"
import script from "./RiseAndFallGraph.vue?vue&type=script&lang=ts&"
export * from "./RiseAndFallGraph.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports